import ForwardRef from "./airplane.js";
import ForwardRef$1 from "./bandage.js";
import ForwardRef$2 from "./car.js";
import ForwardRef$3 from "./cat.js";
import ForwardRef$4 from "./dog.js";
import ForwardRef$5 from "./heartbeat.js";
import ForwardRef$6 from "./house.js";
import ForwardRef$7 from "./motorbike.js";
import ForwardRef$8 from "./people.js";
import ForwardRef$9 from "./suitcase.js";
const IllustrationsList = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  airplane: ForwardRef,
  bandage: ForwardRef$1,
  car: ForwardRef$2,
  cat: ForwardRef$3,
  dog: ForwardRef$4,
  heartbeat: ForwardRef$5,
  house: ForwardRef$6,
  motorbike: ForwardRef$7,
  people: ForwardRef$8,
  suitcase: ForwardRef$9
}, Symbol.toStringTag, { value: "Module" }));
export {
  IllustrationsList as I,
  ForwardRef as airplane,
  ForwardRef$1 as bandage,
  ForwardRef$2 as car,
  ForwardRef$3 as cat,
  ForwardRef$4 as dog,
  ForwardRef$5 as heartbeat,
  ForwardRef$6 as house,
  ForwardRef$7 as motorbike,
  ForwardRef$8 as people,
  ForwardRef$9 as suitcase
};
